import { render, staticRenderFns } from "./LayoutPicker.vue?vue&type=template&id=5023def0&scoped=true&"
import script from "./LayoutPicker.vue?vue&type=script&lang=js&"
export * from "./LayoutPicker.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPicker.vue?vue&type=style&index=0&id=5023def0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5023def0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5023def0')) {
      api.createRecord('5023def0', component.options)
    } else {
      api.reload('5023def0', component.options)
    }
    module.hot.accept("./LayoutPicker.vue?vue&type=template&id=5023def0&scoped=true&", function () {
      api.rerender('5023def0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LayoutPicker.vue"
export default component.exports